import request from "../Utils/request";

export function getData(url: string) {
  return request.get(url);
}
